import styled from "styled-components/macro";

import { Marker } from "shared/assets/icons";
import { colors } from "shared/styles/constants";

export interface StyledMarkerProps {
  isActive?: boolean;
  isDraggable?: boolean;
  canSelect?: boolean;
}

const getDimensions = (canSelect?: boolean) => (canSelect ? "20px" : "30px");

export const StyledMarker = styled(Marker)<StyledMarkerProps>`
  cursor: ${({ isDraggable }) => (isDraggable ? "pointer" : "auto")};
  height: ${({ canSelect }) => getDimensions(canSelect)};
  width: ${({ canSelect }) => getDimensions(canSelect)};

  color: ${colors.red};

  transition: transform 0.3s;

  &:hover {
    transform: ${({ canSelect }) => canSelect && `scale(1.6)`};
  }

  ${({ isActive }) => isActive && "transform: scale(1.6)"};
`;
